<template>
    <section class="container">
        <div class="whiteWrapper center">
            <div class="whiteWrapperSmall" v-if="token != 0">
            	<loading :active.sync="isLoading" 
                    :can-cancel="true" 
                    :on-cancel="onCancel"
                    :is-full-page="fullPage">
                </loading>
                <p v-show="success">New link has been sent successfully</p>
               	<p v-show="requestNewLink">Apologies, It seems that your verification link has expired.
                    Please click on the button below to re-send the invitation.</p>
        	    <input type="hidden" name="token" v-model="token">
        		<button @click="submitForm" v-show="requestNewLink" class="buttonStyle marginTop20">Request a new link</button>
            </div>
            <div class="whiteWrapperSmall" v-else>
                <p>This link is old and not valid. A newer link was requested. Please use the latest invitation link received in email.</p>
            </div>     
        </div>
	</section>
</template>
<script>
export default {
    props: [
        'token',
    ],
    data() {
        return {
        	isLoading: false,
            fullPage: true,
        	requestNewLink: true,
            success: false,
       	}
    },
    methods: {
        submitForm() {
        	this.isLoading = true;
        	axios.post(`/resent-link`, { token: this.token }).then((response) => {
                if(response.data.success) {
                	this.isLoading = false;
                	this.requestNewLink = false;
                    this.success = true;
                }
            }).catch(error => {
            });
        },
        onCancel() {
            console.log('User cancelled the loader.')
        }
    }
}
</script>
